export const accountFrag = `
    id
    code
    name
    type
`;
